export function getCauseInfo({ obstructionType, cause, hindranceType, securityRelated }) {
  const hasCause = !!(cause && String(cause).trim());
  const isClosure = hindranceType === 7;
  const isSecurityRelated = securityRelated === true;
  const showCause = obstructionType !== 1 && (hasCause || !isClosure) && (hasCause || !isSecurityRelated);

  return {
    show: showCause,
    hasCause,
    text: hasCause ? cause : "Verkeersdrukte",
  };
}

export default getCauseInfo;

